var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prop-description-input"},[_c('label',{staticClass:"form-label",attrs:{"for":"motion-descrip"}},[_vm._v("Instructions, et cetera")]),_vm._v(" "),_c('wysiwyg',{attrs:{"id":"motion-descrip"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }